import camelCaseKeys from 'camelcase-keys';
import snakeCaseKeys from 'snakecase-keys';
import type { CamelCase, SnakeCase } from 'type-fest';

export const snakeCase = <T extends string>(text: T): SnakeCase<T> =>
  Object.keys(snakeCaseKeys({ [text]: '' }))[0] as SnakeCase<T>;

export const camelCase = <T extends string>(text: T): CamelCase<T> =>
  Object.keys(camelCaseKeys({ [text]: '' }))[0] as CamelCase<T>;

export const truncate = (string: string, options?: { length: number; separator?: string | RegExp }) => {
  if (!string) return string;
  const omission = '…';
  const length = options?.length || 30;

  if (string.length <= length) return string;

  let truncated = string.slice(0, length - omission.length);

  if (options?.separator) {
    let separatorIndex = -1;

    if (typeof options.separator === 'string') {
      separatorIndex = truncated.lastIndexOf(options.separator);
    } else {
      const matches = truncated.match(options.separator);
      if (matches && matches.length) {
        const lastMatch = matches[matches.length - 1];
        separatorIndex = truncated.lastIndexOf(lastMatch);
      }
    }

    if (separatorIndex !== -1) {
      truncated = truncated.slice(0, separatorIndex);
    }
  }

  return truncated + omission;
};
